import { useSyncExternalStore } from 'react'
import { getLoadError, subscribeLoadError } from '../lib/loadError'
import { ErrorBanner } from './catalog'

/**
 * LoadErrorBanner shows why a page has no data, when the reason is not "no data".
 *
 * It renders the API's own message, which is the useful part: a token without
 * the catalogue capability says "missing capability: catalog:read", and that
 * sentence points at IAM rather than at an empty database.
 */
export function LoadErrorBanner() {
  const message = useSyncExternalStore(subscribeLoadError, getLoadError, getLoadError)
  return <ErrorBanner message={message} />
}
